module.exports = __webpack_public_path__ + "static/transform_logo_2016-3b367e9bf6409902da93ae181e26d2d1.png";